<template>
	<div>
		<div style="font-size: 53px;color: #999;text-align: center;padding-top: 40px;">Freshin</div>
		<div style="font-size: 27px;color: #666;text-align: center;">修改密码</div>
		<div style="text-align: center;margin-top: 20px;">
			<a-form>
				<div style="text-align: left;width: 500px;display: inline-block;">
					<div style="margin-bottom: 20px;">
						<a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" :has-feedback="passwordstate" label="新登录密码"
						 :validate-status="passwordtext" help="登录密码必须是6-20位字母和数字组成">
							<a-input size="large" placeholder="请输入新登录密码" type="password" v-model="password" style="display: inline-block;width: 350px;"
							 @change="passwordchange" />
						</a-form-item>
					</div>
					<div style="margin-bottom: 20px;">
						<a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" :has-feedback="repasswordstate" label="确认新登录密码"
						 :validate-status="repasswordtext" help="必须和上面密码保持一致">
							<a-input size="large" placeholder="请输入新登录密码" type="password" v-model="repassword" style="display: inline-block;width: 350px;"
							 @change="repasswordchange" />
						</a-form-item>
					</div>
					<div style="text-align: center;">
						<a-button type="primary" style="width: 110px;" @click="verification">确认</a-button>
					</div>
				</div>
			</a-form>
		</div>
		<div style="position: absolute;bottom: 30px;text-align: center;width: 100%;font-size: 12px;">powered by Freshin</div>
	</div>
</template>

<script>
	import CryptoJS from 'crypto-js';

	export default {

		data() {
			return {
				phone_number: null,
				password: null,
				passwordstate: false,
				passwordtext: 'success',
				repassword: null,
				repasswordstate: false,
				repasswordtext: 'success',
				labelCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 5
					},
				},
				wrapperCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 12
					},
				},
			}
		},
		created: function() {
			this.phone_number = this.$route.params.phone_number;
		},
		methods: {
			verification() {
				var self = this;
				if (!this.phone_number) {
					return this.$message.error("您的手机号码需要重新验证，请返回重新验证");
				}
				if (this.passwordstate == true && this.repasswordstate == true) {
					var data = {};
					data.password = CryptoJS.MD5(this.password).toString(CryptoJS.enc.Hex);
					data.phone_number = this.phone_number
					this.$axios.post('/basic/modifypassword', {
						params: {
							data: data,
						}
					}).then(function(res) {
						self.$notification.open({
							message: '通知',
							description: res.data,
							onClose: close,
						});
						self.$router.push('login');
					})
				} else {
					this.$message.error("密码有误,请再次确认");
				}
			},
			isPasswd(s) {
				var patrn = /^(\w){6,20}$/;
				if (!patrn.exec(s)) return false
				return true
			},
			passwordchange(e) {
				if (this.isPasswd(e.target.value)) {
					this.passwordstate = true;
					this.passwordtext = 'success'
				} else {
					this.passwordstate = false;
					this.passwordtext = 'error';
				}
			},
			repasswordchange(e) {
				if (e.target.value == this.password) {
					this.repasswordstate = true;
					this.repasswordtext = 'success'
				} else {
					this.repasswordstate = false;
					this.repasswordtext = 'error';
				}
			},
		},

	};
</script>



// WEBPACK FOOTER //
// index.vue?d39cf8d8